import React from "react";
import Navbar from "../shared/Navbar";
import Footer from "../Footer/footer";

const Help = () => {
  return (
    <div>
        <Navbar/>
        <div className="max-w-4xl mx-auto px-6 py-16 text-gray-800">
        <h1 className="text-3xl font-semibold mb-6">Help & Support</h1>

        <p className="mb-6">
            Welcome to the <strong>Arcium Studio Help Center</strong>. Here you can
            find answers to common questions about our services, booking process,
            and how we work. If you need further assistance, our team is always happy
            to help.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-3">
            How can we help you?
        </h2>
        <p className="mb-4">
            Arcium Studio provides architectural planning, interior design,
            consulting, renovation guidance, and project supervision. If you are
            unsure which service best suits your needs, we recommend booking a
            consultation so we can guide you in the right direction.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-3">
            Booking a Consultation
        </h2>
        <p className="mb-4">
            You can book a consultation through our website by filling out the
            contact form. Simply provide your name, email address, phone number, and
            a brief message describing your project. We will contact you as soon as
            possible to schedule a meeting, either online or in person.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-3">
            Project Process
        </h2>
        <p className="mb-4">
            Every project begins with an initial discussion to understand your
            vision, goals, and budget. From there, we develop a clear plan and guide
            you through each phase—from concept and design to execution and
            supervision—ensuring transparency and quality at every step.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-3">
            Changes & Revisions
        </h2>
        <p className="mb-4">
            We understand that ideas evolve. During the design phase, revisions are
            possible to ensure the final result aligns with your expectations.
            Significant changes may affect timelines or costs, which will always be
            communicated clearly.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-3">
            Technical or Website Issues
        </h2>
        <p className="mb-4">
            If you experience any issues while using our website or submitting a
            form, please contact us directly via email. We will address the issue as
            quickly as possible.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-3">
            Contact Support
        </h2>
        <p className="mb-4">
            If you cannot find the information you’re looking for, feel free to
            reach out to us directly. Our team is ready to assist you with any
            questions or concerns.
        </p>

        <p>
            <strong>Email:</strong> info@arciumstudio.com <br />
            <strong>Company:</strong> Arcium Studio
        </p>

        <p className="mt-8 text-sm text-gray-500">
            We aim to respond to all inquiries as quickly as possible.
        </p>
        </div>
        <Footer/>
    </div>  
  );
};

export default Help;
